import Api from "../../index"
import { requestType,endPoints } from "../../../constants/variables"


export const getDashBoardDataByid=id=>{
    return Api(`${endPoints.memberDashboard}/${id}`,null,requestType.GET);
}